import React, { useState, useEffect } from 'react';
import Logo from '../asset/images/home/Logo (1).png';
import Frame10 from '../asset/images/home/Frame 10.png';
import FemaleCrossArms from '../asset/images/home/female teacher crossed arms.png';
import { Link } from 'react-router-dom';
import { courseService } from '../services/courseService';

function About() {
    const [coursePrice, setCoursePrice] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadCoursePrice = async () => {
            try {
                const coursesResult = await courseService.getCourses();
                if (coursesResult.success && coursesResult.data.courses.length > 0) {
                    const firstCourse = coursesResult.data.courses[0];
                    setCoursePrice(Number(firstCourse.individualPrice).toFixed(2));
                }
            } catch (err) {
                console.error('Error loading course price:', err);
            } finally {
                setLoading(false);
            }
        };

        loadCoursePrice();
    }, []);

    return (
        <>
        {/* Header */}
        <header className="bg-white shadow-md">
            <div className="max-w-7xl mx-auto px-6 py-6">
                <div className="flex justify-between items-center">

                    {/* Logo */}
                    <div className="flex items-center">
                        <img src={Logo} alt="READ 21 Logo" className="h-16 w-auto" />
                    </div>

                    {/* Navigation */}
                    <div className="flex items-center space-x-8">
                        <Link to="/about" className="text-gray-700 hover:text-primaryDark font-medium text-lg">
                            <button className="bg-primary text-white px-8 py-3 rounded-md font-medium hover:bg-primaryDark transition-colors text-lg">
                                About
                            </button>
                        </Link>

                        <Link to="/register"
                            className="bg-transparent text-gray-700 px-8 py-3 rounded-md font-medium text-lg
                        hover:bg-primaryDark hover:text-white transition-colors"
                        >
                            Enroll Today
                        </Link>
                    </div>

                </div>
            </div>

            <div className="border-b-2"></div>
        </header>

        {/* Fast Track to Learning to Read */}
        <section className="py-10">
            <div className="max-w-7xl mx-auto px-6">
                <div className="bg-white border-2 rounded-xl shadow-xl p-10">

                    {/* Title */}
                    <h1 className="text-3xl md:text-5xl font-bold text-primary text-center mb-6">
                        Fast Track to Learning to Read
                    </h1>
                    <div className="border-b-2 mb-6"></div>

                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">

                        {/* Left Image */}
                        <div className="flex justify-center">
                            <img
                                src={Frame10}
                                alt="READ 21 Science of Reading Diagram"
                                className="w-full max-w-md h-auto"
                            />
                        </div>

                        {/* Right Side Content */}
                        <div className="space-y-8">

                            {/* Description */}
                            <div>
                                <h3 className="text-lg text-primary mb-4 flex items-start">
                                    <span className="text-primary mr-2">✦</span>
                                    Course Description
                                </h3>

                                <p className="text-primary font-semibold mb-3">Overview:</p>

                                <ul className="space-y-1">
                                    <li className="flex items-start text-sm">
                                        <span className="mr-2">•</span>
                                        Teachers will experience Read 21’s Fast Track to Learning to Read, using the Science of Reading Training.

                                </li>

                                <li className="flex items-start text-sm">
                                    <span className="mr-2">•</span>
                                    Teachers will be able to learn how to teach students how to read in as little as 21 days.
                                </li>

                                <li className="flex items-start text-sm">
                                    <span className="mr-2">•</span>
                                    Teachers will learn the Science of Reading, along with Read 21’s innovative method.
                                </li>

                                <li className="flex items-start text-sm">
                                    <span className="mr-2">•</span>
                                    Teachers will engage with our mock students to have a virtual reality experience that prepares them for the real classroom.
                                </li>
                            </ul>
                        </div>

                        {/* Info */}
                        <div className="space-y-2">
                            <p className="text-primary flex items-start">
                                <span className="text-primary mr-2">✦</span>
                                <strong>Time to Complete Course: 5 Hours</strong>
                            </p>

                            <p className="text-primary flex items-start">
                                <span className="text-primary mr-2">✦</span>
                                <strong>Individual Cost: ${loading ? '...' : (coursePrice || '250.00')}</strong>
                            </p>

                            <p className="text-primary flex items-start">
                                <span className="text-primary mr-2">✦</span>
                                <strong>Group Discounts Available!</strong>
                            </p>
                        </div>
                    </div>
                </div>

                {/* Buttons */}
                <center>
                    <div className="flex flex-wrap gap-4 justify-center mt-8">
                        <Link to="/register">
                            <button className="bg-green hover:bg-greenDark text-white font-semibold px-8 py-3 rounded-md shadow-md transition-colors">
                                Register & Pay
                            </button>
                        </Link>

                        <Link to="/login">
                            <button className="bg-green hover:bg-greenDark text-white font-semibold px-8 py-3 rounded-md shadow-md transition-colors">
                                Already Registered
                            </button>
                        </Link>
                    </div>
                </center>

                {/* Bottom Section */}
                <section className="py-10">
                    <div className="max-w-7xl mx-auto">
                        <div className="bg-white border-2 border-primary rounded-xl pt-10 shadow-lg">

                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

                                {/* Left Image */}
                                <div className="flex justify-center">
                                    <img
                                        src={FemaleCrossArms}
                                        alt="Virtual Teacher"
                                        className="max-w-full h-auto rounded-lg"
                                    />
                                </div>

                                {/* Right Text */}
                                <div className="p-3">
                                    <h3 className="text-2xl font-bold text-primary mb-6">
                                        What will teachers be able to do when they finish Read 21's Fast Track to Learning to Read?
                                    </h3>

                                    <ul className="space-y-1 text-black">
                                        <li className="flex items-start">
                                            <span className="mr-2">•</span>
                                            Teachers will be able to teach students how to read using the Science of Reading.
                                        </li>

                                        <li className="flex items-start">
                                            <span className="mr-2">•</span>
                                            Teachers will be able to teach students within the first quarter of school using only 30 minutes per day.
                                        </li>

                                        <li className="flex items-start">
                                            <span className="mr-2">•</span>
                                            Teachers will be able to pronounce over 175 sounds.
                                        </li>

                                        <li className="flex items-start">
                                            <span className="mr-2">•</span>
                                            Teachers will learn the literacy deficits that most poor readers lack.
                                        </li>

                                        <li className="flex items-start">
                                            <span className="mr-2">•</span>
                                            Teachers will learn how to quickly demonstrate decoding multi-syllabic words.
                                        </li>
                                    </ul>
                                </div>

                            </div>

                        </div>
                    </div>
                </section>

            </div>
        </div>
        </section>

    {/* Footer */}
    <footer className="bg-primary py-10">
        <div className="max-w-7xl mx-auto px-6 text-center">
            <div className="mb-3">
                <img src={Logo} alt="READ 21 Logo" className="mx-auto h-16 w-auto" />
            </div>
            <p className="text-white text-lg">Read 21 © 2025 - All Rights Reserved</p>
        </div>
    </footer>
</>
);
}

export default About;
